import styled from "styled-components";
import { checkbox } from "../../styles/variable";

export const Text = styled.span`
  margin-left: 5px;
  color: ${({ secondary }) => (secondary ? "#333333" : "#2f0a77")};
  font-size: 16px;
  font-family: Roboto Condensed;
`;

export const Checkbox = styled.div`
  z-index: 0;
  position: relative;
  display: flex;
  color: #000;
  font-family: "Roboto";
  font-size: 16px;
  line-height: 1.5;
  left: 0;

  /* Input */
  input {
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    z-index: -1;
    position: absolute;
    left: -10px;
    top: -8px;
    display: block;
    margin: 0;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    background-color: rgba(66, 82, 110, 0.65);
    box-shadow: none;
    outline: none;
    opacity: 0;
    transform: scale(1);
    pointer-events: none;
    transition: opacity 0.3s, transform 0.2s;
  }

  /* Span */
  span {
    display: inline-block;
    width: auto;
    cursor: pointer;
    position: relative;
  }

  /* Box */
  .pure-material-checkbox > span::before {
    color: ${({ color }) => color || "#333333"};
    content: "";
    display: inline-block;
    box-sizing: border-box;
    margin: 3px 5px 3px 0px;
    border: solid 2px;
    border-color: ${({ secondary }) =>
      secondary ? "#333333" : "currentColor"};
    border-radius: 2px;
    width: 18px;
    height: 18px;
    vertical-align: top;
    transition: border-color 0.2s, background-color 0.2s;
  }

  /* Checkmark */
  .pure-material-checkbox > span::after {
    content: "";
    display: block;
    position: absolute;
    top: 3px;
    width: 10px;
    height: 5px;
    border: solid 2px transparent;
    border-right: none;
    border-top: none;
    transform: translate(3px, 4px) rotate(-45deg);
  }

  /* Checked, Indeterminate */
  .pure-material-checkbox > input:checked,
  .pure-material-checkbox > input:indeterminate {
    background-color: ${({ secondary }) =>
      secondary ? "#333333" : checkbox.colorEffect};
  }

  input:checked + span::before,
  input:indeterminate + span::before {
    border-color: ${({ secondary, borderColor }) =>
      secondary ? "#333333" : borderColor || checkbox.borderColor};
    background-color: ${({ secondary, background }) =>
      secondary ? "#333333" : background || checkbox.background};
  }

  .pure-material-checkbox > input:checked + span::after,
  .pure-material-checkbox > input:indeterminate + span::after {
    border-color: ${({ secondary }) =>
      secondary ? "#fff" : checkbox.colorIcon};
  }

  .pure-material-checkbox > input:indeterminate + span::after {
    border-left: none;
    transform: translate(4px, 3px);
  }

  /* Hover, Focus */
  .pure-material-checkbox:hover > input {
    opacity: 0.04;
  }

  .pure-material-checkbox > input:focus {
    opacity: 0.12;
  }

  .pure-material-checkbox:hover > input:focus {
    opacity: 0.16;
  }

  /* Active */
  .pure-material-checkbox > input:active {
    opacity: 1;
    transform: scale(0);
    transition: transform 0s, opacity 0s;
  }

  .pure-material-checkbox > input:active + span::before {
    border-color: $primary-2;
  }

  .pure-material-checkbox > input:checked:active + span::before {
    border-color: transparent;
    background-color: rgba(66, 82, 110, 0.65);
  }

  /* Disabled */
  .pure-material-checkbox > input:disabled {
    opacity: 0;
  }

  .pure-material-checkbox > input:disabled + span {
    color: gray;
    cursor: initial;
  }

  .pure-material-checkbox > input:disabled + span::before {
    border-color: currentColor;
  }

  .pure-material-checkbox > input:checked:disabled + span::before,
  .pure-material-checkbox > input:indeterminate:disabled + span::before {
    border-color: transparent;
    background-color: currentColor;
  }
`;

export const Content = styled.div`
  width: auto;
`;
